import { axiosInstance } from "../instance";

export const getBrandList = (params) => axiosInstance({ method: 'get', url: `/api/modelConfig/brands`, params })


// 获取平台数据列表
export const getPlatformList = (params) => axiosInstance({ method: 'get', url: `/api/modelConfig/platforms`, params })


// 获取model列表2
export const getModel2 = (data) => axiosInstance({ method: 'get', url: '/api/modelConfig/modelPageByStbIds', params: data })


// 获取所有语言
export const getAllLangApi = () => axiosInstance({ method: 'get', url: '/api/modelConfig/languageConfig/list' })


// 获取国家列表
export const getCountriesApi = ((params?) => {
    return axiosInstance({ method: 'get', url: '/api/modelConfig/countries', params })
})